import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import MxRatingField, {
  IMxRatingFieldProps
} from "@rf-l1/form/rating/MxRatingField";

export type IMxFormRatingFieldProps = IMxRatingFieldProps;

const MxFormRatingField = (props: IMxFormRatingFieldProps) => {
  const { onChange, onBlur, name, value, invalid, id } =
    useMxFieldControllerContext();

  const handleChange = (_event: React.SyntheticEvent, newValue: number | null) => {
    onChange({
      target: {
        value: newValue,
        name: name
      }
    });
  };

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <MxRatingField
      {...props}
      id={id}
      error={invalid}
      value={Number(value) || 0}
      onChange={handleChange}
      onBlur={handleBlur}
      name={name}
    />
  );
};

export default MxFormRatingField;
